import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { IFlagsmithFeature, useFlags } from '@flagsmith/flagsmith/react';
import { viewer3dSelectors } from '@viewer3D/redux';
import { projectSelectors } from '@projects/redux';
import { Entity } from '@core/types';

export const isEnabledForProject = (
  flag: IFlagsmithFeature<string | number | boolean | null>,
  projectsData: Entity | undefined,
) => {
  const projectId = projectsData?.id;

  if (!projectId || !flag.enabled || !flag?.value || typeof flag.value !== 'string') {
    return false;
  }

  try {
    const value = JSON.parse(flag.value) as {
      includedProjectIds?: string[];
      excludedProjectIds?: string[];
    };

    const { includedProjectIds, excludedProjectIds } = value;

    if (Array.isArray(includedProjectIds)) {
      return includedProjectIds.includes(projectId);
    }

    if (Array.isArray(excludedProjectIds)) {
      return !excludedProjectIds.includes(projectId);
    }

    return false;
  } catch (_error) {
    return false;
  }
};

export const useIssueReportingEnabled = () => {
  const selectedProjectId = useSelector(viewer3dSelectors.selectedProjectId);
  const { issue_reporting_enabled: flag } = useFlags(['issue_reporting_enabled']);
  const projectsData = useSelector(projectSelectors.selectById(selectedProjectId));

  const isEnabled = useMemo(() => {
    return isEnabledForProject(flag, projectsData);
  }, [projectsData, flag]);

  return { isIssueReportingEnabled: isEnabled };
};
